import type { TodoItemData } from '@/types/tools';
import { TODO_KEY_CONTENT_LENGTH } from '@/constants/ui.constants';

/**
 * Generates a unique key for a todo item in a list
 * @param todo - The todo item data
 * @param index - The index of the todo in the list
 * @returns A unique key string
 */
export function generateTodoKey(
  todo: TodoItemData,
  index: number
): string {
  const contentHash = todo.content
    .slice(0, TODO_KEY_CONTENT_LENGTH)
    .replace(/\s+/g, '-');
  return `${index}-${contentHash}-${todo.status}`;
}

export const encryptText = (text: string, encryptionKey: string): string => {
  let result = '';
  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(
      text.charCodeAt(i) ^ encryptionKey.charCodeAt(i % encryptionKey.length)
    );
  }
  return btoa(result); // Base64 encode
};

export const decryptText = (
  encryptedText: string,
  encryptionKey: string
): string => {
  try {
    const decoded = atob(encryptedText); // Base64 decode
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
      result += String.fromCharCode(
        decoded.charCodeAt(i) ^
          encryptionKey.charCodeAt(i % encryptionKey.length)
      );
    }
    return result;
  } catch (error) {
    console.warn('Failed to decrypt data:', error);
    return '';
  }
};
